import { apiGet, apiSend } from './client';
import type { Environment } from '../constants';
import type {
  IProvisioningRun,
  IProvisionTenantInput,
  IStartRunInput,
  ITenantSummary,
  ProvisioningStepStatus,
} from '../types';

const runsPath = (tenant: string) => `/tenants/${encodeURIComponent(tenant)}/runs`;

export const createTenant = (
  environment: Environment,
  input: IProvisionTenantInput,
): Promise<{
  data: { tenant: Pick<ITenantSummary, 'name' | 'display_name' | 'status'>; run: IProvisioningRun };
}> => apiSend(environment, '/tenants', 'POST', input);

export const getProvisioningRuns = (
  environment: Environment,
  tenant: string,
): Promise<{ data: IProvisioningRun[] }> => apiGet(environment, runsPath(tenant));

export const startProvisioningRun = (
  environment: Environment,
  tenant: string,
  input: IStartRunInput,
): Promise<{ data: IProvisioningRun }> => apiSend(environment, runsPath(tenant), 'POST', input);

export const patchProvisioningStep = (
  environment: Environment,
  tenant: string,
  runId: string,
  step: string,
  status: ProvisioningStepStatus,
): Promise<{ data: IProvisioningRun }> =>
  apiSend(
    environment,
    `${runsPath(tenant)}/${encodeURIComponent(runId)}/steps/${encodeURIComponent(step)}`,
    'PATCH',
    { status },
  );
